import { AriaCoreDatapoint } from "./AriaCoreDatapoint";
import type { AnalyticsCoreEventNames, AnalyticsEventNames } from "owa-analytics-events";
import type { CustomData, DatapointOptions } from "owa-analytics-types";
import type { MailboxInfo } from "owa-client-types";

export default class UsageCoreDatapoint extends AriaCoreDatapoint {
    constructor(eventName: AnalyticsEventNames | AnalyticsCoreEventNames, mailbox: MailboxInfo | undefined, customData?: CustomData, options?: DatapointOptions) {
        super(eventName, mailbox, customData, options);
    }
}
